import * as React from "react";
import * as styles from "./cta.module.css";

const CtaBackground = () => {
    return (
        <svg className={styles.cta__background} viewBox="0 0 1360 468" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.3">
                <mask
                    id="mask0_170_4440"
                    style={{maskType: "alpha"}}
                    maskUnits="userSpaceOnUse"
                    x="-1"
                    y="0"
                    width="1361"
                    height="1130"
                >
                    <rect width="1360" height="1130" transform="translate(-1)" fill="url(#paint0_radial_170_4440)" />
                </mask>
                <g mask="url(#mask0_170_4440)">
                    <g clipPath="url(#clip0_170_4440)">
                        <mask id="path-3-inside-1_170_4440" fill="white">
                            <path d="M-51 0H54V105H-51V0Z" />
                        </mask>
                        <path
                            d="M54 105V106.091H55.0906V105H54ZM54 0H52.9094V105H54H55.0906V0H54ZM54 105V103.909H-51V105V106.091H54V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-3-inside-1_170_4440)"
                        />
                        <mask id="path-5-inside-2_170_4440" fill="white">
                            <path d="M54 0H159V105H54V0Z" />
                        </mask>
                        <path
                            d="M159 105V106.091H160.091V105H159ZM159 0H157.909V105H159H160.091V0H159ZM159 105V103.909H54V105V106.091H159V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-5-inside-2_170_4440)"
                        />
                        <mask id="path-7-inside-3_170_4440" fill="white">
                            <path d="M159 0H264V105H159V0Z" />
                        </mask>
                        <path
                            d="M264 105V106.091H265.091V105H264ZM264 0H262.909V105H264H265.091V0H264ZM264 105V103.909H159V105V106.091H264V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-7-inside-3_170_4440)"
                        />
                        <mask id="path-9-inside-4_170_4440" fill="white">
                            <path d="M264 0H369V105H264V0Z" />
                        </mask>
                        <path
                            d="M369 105V106.091H370.091V105H369ZM369 0H367.909V105H369H370.091V0H369ZM369 105V103.909H264V105V106.091H369V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-9-inside-4_170_4440)"
                        />
                        <mask id="path-11-inside-5_170_4440" fill="white">
                            <path d="M369 0H474V105H369V0Z" />
                        </mask>
                        <path
                            d="M474 105V106.091H475.091V105H474ZM474 0H472.909V105H474H475.091V0H474ZM474 105V103.909H369V105V106.091H474V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-11-inside-5_170_4440)"
                        />
                        <mask id="path-13-inside-6_170_4440" fill="white">
                            <path d="M474 0H579V105H474V0Z" />
                        </mask>
                        <path
                            d="M579 105V106.091H580.091V105H579ZM579 0H577.909V105H579H580.091V0H579ZM579 105V103.909H474V105V106.091H579V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-13-inside-6_170_4440)"
                        />
                        <mask id="path-15-inside-7_170_4440" fill="white">
                            <path d="M579 0H684V105H579V0Z" />
                        </mask>
                        <path
                            d="M684 105V106.091H685.091V105H684ZM684 0H682.909V105H684H685.091V0H684ZM684 105V103.909H579V105V106.091H684V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-15-inside-7_170_4440)"
                        />
                        <mask id="path-17-inside-8_170_4440" fill="white">
                            <path d="M684 0H789V105H684V0Z" />
                        </mask>
                        <path
                            d="M789 105V106.091H790.091V105H789ZM789 0H787.909V105H789H790.091V0H789ZM789 105V103.909H684V105V106.091H789V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-17-inside-8_170_4440)"
                        />
                        <mask id="path-19-inside-9_170_4440" fill="white">
                            <path d="M789 0H894V105H789V0Z" />
                        </mask>
                        <path
                            d="M894 105V106.091H895.091V105H894ZM894 0H892.909V105H894H895.091V0H894ZM894 105V103.909H789V105V106.091H894V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-19-inside-9_170_4440)"
                        />
                        <mask id="path-21-inside-10_170_4440" fill="white">
                            <path d="M894 0H999V105H894V0Z" />
                        </mask>
                        <path
                            d="M999 105V106.091H1000.09V105H999ZM999 0H997.909V105H999H1000.09V0H999ZM999 105V103.909H894V105V106.091H999V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-21-inside-10_170_4440)"
                        />
                        <mask id="path-23-inside-11_170_4440" fill="white">
                            <path d="M999 0H1104V105H999V0Z" />
                        </mask>
                        <path
                            d="M1104 105V106.091H1105.09V105H1104ZM1104 0H1102.91V105H1104H1105.09V0H1104ZM1104 105V103.909H999V105V106.091H1104V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-23-inside-11_170_4440)"
                        />
                        <mask id="path-25-inside-12_170_4440" fill="white">
                            <path d="M1104 0H1209V105H1104V0Z" />
                        </mask>
                        <path
                            d="M1209 105V106.091H1210.09V105H1209ZM1209 0H1207.91V105H1209H1210.09V0H1209ZM1209 105V103.909H1104V105V106.091H1209V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-25-inside-12_170_4440)"
                        />
                        <mask id="path-27-inside-13_170_4440" fill="white">
                            <path d="M1209 0H1314V105H1209V0Z" />
                        </mask>
                        <path
                            d="M1314 105V106.091H1315.09V105H1314ZM1314 0H1312.91V105H1314H1315.09V0H1314ZM1314 105V103.909H1209V105V106.091H1314V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-27-inside-13_170_4440)"
                        />
                        <mask id="path-29-inside-14_170_4440" fill="white">
                            <path d="M1314 0H1419V105H1314V0Z" />
                        </mask>
                        <path
                            d="M1419 105V106.091H1420.09V105H1419ZM1419 0H1417.91V105H1419H1420.09V0H1419ZM1419 105V103.909H1314V105V106.091H1419V105Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-29-inside-14_170_4440)"
                        />
                        <mask id="path-31-inside-15_170_4440" fill="white">
                            <path d="M-51 105H54V210H-51V105Z" />
                        </mask>
                        <path
                            d="M54 210V211.091H55.0906V210H54ZM54 105H52.9094V210H54H55.0906V105H54ZM54 210V208.909H-51V210V211.091H54V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-31-inside-15_170_4440)"
                        />
                        <mask id="path-33-inside-16_170_4440" fill="white">
                            <path d="M54 105H159V210H54V105Z" />
                        </mask>
                        <path
                            d="M159 210V211.091H160.091V210H159ZM159 105H157.909V210H159H160.091V105H159ZM159 210V208.909H54V210V211.091H159V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-33-inside-16_170_4440)"
                        />
                        <mask id="path-35-inside-17_170_4440" fill="white">
                            <path d="M159 105H264V210H159V105Z" />
                        </mask>
                        <path d="M159 105H264V210H159V105Z" fill="#F2F4F7" fillOpacity="0.1" />
                        <path
                            d="M264 210V211.091H265.091V210H264ZM264 105H262.909V210H264H265.091V105H264ZM264 210V208.909H159V210V211.091H264V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-35-inside-17_170_4440)"
                        />
                        <mask id="path-37-inside-18_170_4440" fill="white">
                            <path d="M264 105H369V210H264V105Z" />
                        </mask>
                        <path
                            d="M369 210V211.091H370.091V210H369ZM369 105H367.909V210H369H370.091V105H369ZM369 210V208.909H264V210V211.091H369V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-37-inside-18_170_4440)"
                        />
                        <mask id="path-39-inside-19_170_4440" fill="white">
                            <path d="M369 105H474V210H369V105Z" />
                        </mask>
                        <path
                            d="M474 210V211.091H475.091V210H474ZM474 105H472.909V210H474H475.091V105H474ZM474 210V208.909H369V210V211.091H474V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-39-inside-19_170_4440)"
                        />
                        <mask id="path-41-inside-20_170_4440" fill="white">
                            <path d="M474 105H579V210H474V105Z" />
                        </mask>
                        <path
                            d="M579 210V211.091H580.091V210H579ZM579 105H577.909V210H579H580.091V105H579ZM579 210V208.909H474V210V211.091H579V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-41-inside-20_170_4440)"
                        />
                        <mask id="path-43-inside-21_170_4440" fill="white">
                            <path d="M579 105H684V210H579V105Z" />
                        </mask>
                        <path
                            d="M684 210V211.091H685.091V210H684ZM684 105H682.909V210H684H685.091V105H684ZM684 210V208.909H579V210V211.091H684V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-43-inside-21_170_4440)"
                        />
                        <mask id="path-45-inside-22_170_4440" fill="white">
                            <path d="M684 105H789V210H684V105Z" />
                        </mask>
                        <path
                            d="M789 210V211.091H790.091V210H789ZM789 105H787.909V210H789H790.091V105H789ZM789 210V208.909H684V210V211.091H789V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-45-inside-22_170_4440)"
                        />
                        <mask id="path-47-inside-23_170_4440" fill="white">
                            <path d="M789 105H894V210H789V105Z" />
                        </mask>
                        <path
                            d="M894 210V211.091H895.091V210H894ZM894 105H892.909V210H894H895.091V105H894ZM894 210V208.909H789V210V211.091H894V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-47-inside-23_170_4440)"
                        />
                        <mask id="path-49-inside-24_170_4440" fill="white">
                            <path d="M894 105H999V210H894V105Z" />
                        </mask>
                        <path
                            d="M999 210V211.091H1000.09V210H999ZM999 105H997.909V210H999H1000.09V105H999ZM999 210V208.909H894V210V211.091H999V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-49-inside-24_170_4440)"
                        />
                        <mask id="path-51-inside-25_170_4440" fill="white">
                            <path d="M999 105H1104V210H999V105Z" />
                        </mask>
                        <path
                            d="M1104 210V211.091H1105.09V210H1104ZM1104 105H1102.91V210H1104H1105.09V105H1104ZM1104 210V208.909H999V210V211.091H1104V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-51-inside-25_170_4440)"
                        />
                        <mask id="path-53-inside-26_170_4440" fill="white">
                            <path d="M1104 105H1209V210H1104V105Z" />
                        </mask>
                        <path d="M1104 105H1209V210H1104V105Z" fill="#F2F4F7" fillOpacity="0.1" />
                        <path
                            d="M1209 210V211.091H1210.09V210H1209ZM1209 105H1207.91V210H1209H1210.09V105H1209ZM1209 210V208.909H1104V210V211.091H1209V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-53-inside-26_170_4440)"
                        />
                        <mask id="path-55-inside-27_170_4440" fill="white">
                            <path d="M1209 105H1314V210H1209V105Z" />
                        </mask>
                        <path
                            d="M1314 210V211.091H1315.09V210H1314ZM1314 105H1312.91V210H1314H1315.09V105H1314ZM1314 210V208.909H1209V210V211.091H1314V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-55-inside-27_170_4440)"
                        />
                        <mask id="path-57-inside-28_170_4440" fill="white">
                            <path d="M1314 105H1419V210H1314V105Z" />
                        </mask>
                        <path
                            d="M1419 210V211.091H1420.09V210H1419ZM1419 105H1417.91V210H1419H1420.09V105H1419ZM1419 210V208.909H1314V210V211.091H1419V210Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-57-inside-28_170_4440)"
                        />
                        <mask id="path-59-inside-29_170_4440" fill="white">
                            <path d="M-51 210H54V315H-51V210Z" />
                        </mask>
                        <path
                            d="M54 315V316.091H55.0906V315H54ZM54 210H52.9094V315H54H55.0906V210H54ZM54 315V313.909H-51V315V316.091H54V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-59-inside-29_170_4440)"
                        />
                        <mask id="path-61-inside-30_170_4440" fill="white">
                            <path d="M54 210H159V315H54V210Z" />
                        </mask>
                        <path
                            d="M159 315V316.091H160.091V315H159ZM159 210H157.909V315H159H160.091V210H159ZM159 315V313.909H54V315V316.091H159V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-61-inside-30_170_4440)"
                        />
                        <mask id="path-63-inside-31_170_4440" fill="white">
                            <path d="M159 210H264V315H159V210Z" />
                        </mask>
                        <path
                            d="M264 315V316.091H265.091V315H264ZM264 210H262.909V315H264H265.091V210H264ZM264 315V313.909H159V315V316.091H264V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-63-inside-31_170_4440)"
                        />
                        <mask id="path-65-inside-32_170_4440" fill="white">
                            <path d="M264 210H369V315H264V210Z" />
                        </mask>
                        <path
                            d="M369 315V316.091H370.091V315H369ZM369 210H367.909V315H369H370.091V210H369ZM369 315V313.909H264V315V316.091H369V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-65-inside-32_170_4440)"
                        />
                        <mask id="path-67-inside-33_170_4440" fill="white">
                            <path d="M369 210H474V315H369V210Z" />
                        </mask>
                        <path d="M369 210H474V315H369V210Z" fill="#F2F4F7" fillOpacity="0.1" />
                        <path
                            d="M474 315V316.091H475.091V315H474ZM474 210H472.909V315H474H475.091V210H474ZM474 315V313.909H369V315V316.091H474V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-67-inside-33_170_4440)"
                        />
                        <mask id="path-69-inside-34_170_4440" fill="white">
                            <path d="M474 210H579V315H474V210Z" />
                        </mask>
                        <path
                            d="M579 315V316.091H580.091V315H579ZM579 210H577.909V315H579H580.091V210H579ZM579 315V313.909H474V315V316.091H579V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-69-inside-34_170_4440)"
                        />
                        <mask id="path-71-inside-35_170_4440" fill="white">
                            <path d="M579 210H684V315H579V210Z" />
                        </mask>
                        <path
                            d="M684 315V316.091H685.091V315H684ZM684 210H682.909V315H684H685.091V210H684ZM684 315V313.909H579V315V316.091H684V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-71-inside-35_170_4440)"
                        />
                        <mask id="path-73-inside-36_170_4440" fill="white">
                            <path d="M684 210H789V315H684V210Z" />
                        </mask>
                        <path
                            d="M789 315V316.091H790.091V315H789ZM789 210H787.909V315H789H790.091V210H789ZM789 315V313.909H684V315V316.091H789V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-73-inside-36_170_4440)"
                        />
                        <mask id="path-75-inside-37_170_4440" fill="white">
                            <path d="M789 210H894V315H789V210Z" />
                        </mask>
                        <path d="M789 210H894V315H789V210Z" fill="#F2F4F7" fillOpacity="0.1" />
                        <path
                            d="M894 315V316.091H895.091V315H894ZM894 210H892.909V315H894H895.091V210H894ZM894 315V313.909H789V315V316.091H894V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-75-inside-37_170_4440)"
                        />
                        <mask id="path-77-inside-38_170_4440" fill="white">
                            <path d="M894 210H999V315H894V210Z" />
                        </mask>
                        <path
                            d="M999 315V316.091H1000.09V315H999ZM999 210H997.909V315H999H1000.09V210H999ZM999 315V313.909H894V315V316.091H999V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-77-inside-38_170_4440)"
                        />
                        <mask id="path-79-inside-39_170_4440" fill="white">
                            <path d="M999 210H1104V315H999V210Z" />
                        </mask>
                        <path
                            d="M1104 315V316.091H1105.09V315H1104ZM1104 210H1102.91V315H1104H1105.09V210H1104ZM1104 315V313.909H999V315V316.091H1104V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-79-inside-39_170_4440)"
                        />
                        <mask id="path-81-inside-40_170_4440" fill="white">
                            <path d="M1104 210H1209V315H1104V210Z" />
                        </mask>
                        <path
                            d="M1209 315V316.091H1210.09V315H1209ZM1209 210H1207.91V315H1209H1210.09V210H1209ZM1209 315V313.909H1104V315V316.091H1209V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-81-inside-40_170_4440)"
                        />
                        <mask id="path-83-inside-41_170_4440" fill="white">
                            <path d="M1209 210H1314V315H1209V210Z" />
                        </mask>
                        <path
                            d="M1314 315V316.091H1315.09V315H1314ZM1314 210H1312.91V315H1314H1315.09V210H1314ZM1314 315V313.909H1209V315V316.091H1314V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-83-inside-41_170_4440)"
                        />
                        <mask id="path-85-inside-42_170_4440" fill="white">
                            <path d="M1314 210H1419V315H1314V210Z" />
                        </mask>
                        <path
                            d="M1419 315V316.091H1420.09V315H1419ZM1419 210H1417.91V315H1419H1420.09V210H1419ZM1419 315V313.909H1314V315V316.091H1419V315Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-85-inside-42_170_4440)"
                        />
                        <mask id="path-87-inside-43_170_4440" fill="white">
                            <path d="M-51 315H54V420H-51V315Z" />
                        </mask>
                        <path
                            d="M54 420V421.091H55.0906V420H54ZM54 315H52.9094V420H54H55.0906V315H54ZM54 420V418.909H-51V420V421.091H54V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-87-inside-43_170_4440)"
                        />
                        <mask id="path-89-inside-44_170_4440" fill="white">
                            <path d="M54 315H159V420H54V315Z" />
                        </mask>
                        <path
                            d="M159 420V421.091H160.091V420H159ZM159 315H157.909V420H159H160.091V315H159ZM159 420V418.909H54V420V421.091H159V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-89-inside-44_170_4440)"
                        />
                        <mask id="path-91-inside-45_170_4440" fill="white">
                            <path d="M159 315H264V420H159V315Z" />
                        </mask>
                        <path
                            d="M264 420V421.091H265.091V420H264ZM264 315H262.909V420H264H265.091V315H264ZM264 420V418.909H159V420V421.091H264V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-91-inside-45_170_4440)"
                        />
                        <mask id="path-93-inside-46_170_4440" fill="white">
                            <path d="M264 315H369V420H264V315Z" />
                        </mask>
                        <path
                            d="M369 420V421.091H370.091V420H369ZM369 315H367.909V420H369H370.091V315H369ZM369 420V418.909H264V420V421.091H369V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-93-inside-46_170_4440)"
                        />
                        <mask id="path-95-inside-47_170_4440" fill="white">
                            <path d="M369 315H474V420H369V315Z" />
                        </mask>
                        <path
                            d="M474 420V421.091H475.091V420H474ZM474 315H472.909V420H474H475.091V315H474ZM474 420V418.909H369V420V421.091H474V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-95-inside-47_170_4440)"
                        />
                        <mask id="path-97-inside-48_170_4440" fill="white">
                            <path d="M474 315H579V420H474V315Z" />
                        </mask>
                        <path
                            d="M579 420V421.091H580.091V420H579ZM579 315H577.909V420H579H580.091V315H579ZM579 420V418.909H474V420V421.091H579V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-97-inside-48_170_4440)"
                        />
                        <mask id="path-99-inside-49_170_4440" fill="white">
                            <path d="M579 315H684V420H579V315Z" />
                        </mask>
                        <path
                            d="M684 420V421.091H685.091V420H684ZM684 315H682.909V420H684H685.091V315H684ZM684 420V418.909H579V420V421.091H684V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-99-inside-49_170_4440)"
                        />
                        <mask id="path-101-inside-50_170_4440" fill="white">
                            <path d="M684 315H789V420H684V315Z" />
                        </mask>
                        <path
                            d="M789 420V421.091H790.091V420H789ZM789 315H787.909V420H789H790.091V315H789ZM789 420V418.909H684V420V421.091H789V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-101-inside-50_170_4440)"
                        />
                        <mask id="path-103-inside-51_170_4440" fill="white">
                            <path d="M789 315H894V420H789V315Z" />
                        </mask>
                        <path
                            d="M894 420V421.091H895.091V420H894ZM894 315H892.909V420H894H895.091V315H894ZM894 420V418.909H789V420V421.091H894V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-103-inside-51_170_4440)"
                        />
                        <mask id="path-105-inside-52_170_4440" fill="white">
                            <path d="M894 315H999V420H894V315Z" />
                        </mask>
                        <path
                            d="M999 420V421.091H1000.09V420H999ZM999 315H997.909V420H999H1000.09V315H999ZM999 420V418.909H894V420V421.091H999V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-105-inside-52_170_4440)"
                        />
                        <mask id="path-107-inside-53_170_4440" fill="white">
                            <path d="M999 315H1104V420H999V315Z" />
                        </mask>
                        <path
                            d="M1104 420V421.091H1105.09V420H1104ZM1104 315H1102.91V420H1104H1105.09V315H1104ZM1104 420V418.909H999V420V421.091H1104V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-107-inside-53_170_4440)"
                        />
                        <mask id="path-109-inside-54_170_4440" fill="white">
                            <path d="M1104 315H1209V420H1104V315Z" />
                        </mask>
                        <path d="M1104 315H1209V420H1104V315Z" fill="#F2F4F7" fillOpacity="0.1" />
                        <path
                            d="M1209 420V421.091H1210.09V420H1209ZM1209 315H1207.91V420H1209H1210.09V315H1209ZM1209 420V418.909H1104V420V421.091H1209V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-109-inside-54_170_4440)"
                        />
                        <mask id="path-111-inside-55_170_4440" fill="white">
                            <path d="M1209 315H1314V420H1209V315Z" />
                        </mask>
                        <path
                            d="M1314 420V421.091H1315.09V420H1314ZM1314 315H1312.91V420H1314H1315.09V315H1314ZM1314 420V418.909H1209V420V421.091H1314V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-111-inside-55_170_4440)"
                        />
                        <mask id="path-113-inside-56_170_4440" fill="white">
                            <path d="M1314 315H1419V420H1314V315Z" />
                        </mask>
                        <path
                            d="M1419 420V421.091H1420.09V420H1419ZM1419 315H1417.91V420H1419H1420.09V315H1419ZM1419 420V418.909H1314V420V421.091H1419V420Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-113-inside-56_170_4440)"
                        />
                        <mask id="path-115-inside-57_170_4440" fill="white">
                            <path d="M-51 420H54V525H-51V420Z" />
                        </mask>
                        <path
                            d="M54 525V526.091H55.0906V525H54ZM54 420H52.9094V525H54H55.0906V420H54ZM54 525V523.909H-51V525V526.091H54V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-115-inside-57_170_4440)"
                        />
                        <mask id="path-117-inside-58_170_4440" fill="white">
                            <path d="M54 420H159V525H54V420Z" />
                        </mask>
                        <path
                            d="M159 525V526.091H160.091V525H159ZM159 420H157.909V525H159H160.091V420H159ZM159 525V523.909H54V525V526.091H159V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-117-inside-58_170_4440)"
                        />
                        <mask id="path-119-inside-59_170_4440" fill="white">
                            <path d="M159 420H264V525H159V420Z" />
                        </mask>
                        <path
                            d="M264 525V526.091H265.091V525H264ZM264 420H262.909V525H264H265.091V420H264ZM264 525V523.909H159V525V526.091H264V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-119-inside-59_170_4440)"
                        />
                        <mask id="path-121-inside-60_170_4440" fill="white">
                            <path d="M264 420H369V525H264V420Z" />
                        </mask>
                        <path
                            d="M369 525V526.091H370.091V525H369ZM369 420H367.909V525H369H370.091V420H369ZM369 525V523.909H264V525V526.091H369V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-121-inside-60_170_4440)"
                        />
                        <mask id="path-123-inside-61_170_4440" fill="white">
                            <path d="M369 420H474V525H369V420Z" />
                        </mask>
                        <path
                            d="M474 525V526.091H475.091V525H474ZM474 420H472.909V525H474H475.091V420H474ZM474 525V523.909H369V525V526.091H474V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-123-inside-61_170_4440)"
                        />
                        <mask id="path-125-inside-62_170_4440" fill="white">
                            <path d="M474 420H579V525H474V420Z" />
                        </mask>
                        <path d="M474 420H579V525H474V420Z" fill="#F2F4F7" fillOpacity="0.1" />
                        <path
                            d="M579 525V526.091H580.091V525H579ZM579 420H577.909V525H579H580.091V420H579ZM579 525V523.909H474V525V526.091H579V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-125-inside-62_170_4440)"
                        />
                        <mask id="path-127-inside-63_170_4440" fill="white">
                            <path d="M579 420H684V525H579V420Z" />
                        </mask>
                        <path
                            d="M684 525V526.091H685.091V525H684ZM684 420H682.909V525H684H685.091V420H684ZM684 525V523.909H579V525V526.091H684V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-127-inside-63_170_4440)"
                        />
                        <mask id="path-129-inside-64_170_4440" fill="white">
                            <path d="M684 420H789V525H684V420Z" />
                        </mask>
                        <path
                            d="M789 525V526.091H790.091V525H789ZM789 420H787.909V525H789H790.091V420H789ZM789 525V523.909H684V525V526.091H789V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-129-inside-64_170_4440)"
                        />
                        <mask id="path-131-inside-65_170_4440" fill="white">
                            <path d="M789 420H894V525H789V420Z" />
                        </mask>
                        <path
                            d="M894 525V526.091H895.091V525H894ZM894 420H892.909V525H894H895.091V420H894ZM894 525V523.909H789V525V526.091H894V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-131-inside-65_170_4440)"
                        />
                        <mask id="path-133-inside-66_170_4440" fill="white">
                            <path d="M894 420H999V525H894V420Z" />
                        </mask>
                        <path
                            d="M999 525V526.091H1000.09V525H999ZM999 420H997.909V525H999H1000.09V420H999ZM999 525V523.909H894V525V526.091H999V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-133-inside-66_170_4440)"
                        />
                        <mask id="path-135-inside-67_170_4440" fill="white">
                            <path d="M999 420H1104V525H999V420Z" />
                        </mask>
                        <path
                            d="M1104 525V526.091H1105.09V525H1104ZM1104 420H1102.91V525H1104H1105.09V420H1104ZM1104 525V523.909H999V525V526.091H1104V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-135-inside-67_170_4440)"
                        />
                        <mask id="path-137-inside-68_170_4440" fill="white">
                            <path d="M1104 420H1209V525H1104V420Z" />
                        </mask>
                        <path
                            d="M1209 525V526.091H1210.09V525H1209ZM1209 420H1207.91V525H1209H1210.09V420H1209ZM1209 525V523.909H1104V525V526.091H1209V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-137-inside-68_170_4440)"
                        />
                        <mask id="path-139-inside-69_170_4440" fill="white">
                            <path d="M1209 420H1314V525H1209V420Z" />
                        </mask>
                        <path
                            d="M1314 525V526.091H1315.09V525H1314ZM1314 420H1312.91V525H1314H1315.09V420H1314ZM1314 525V523.909H1209V525V526.091H1314V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-139-inside-69_170_4440)"
                        />
                        <mask id="path-141-inside-70_170_4440" fill="white">
                            <path d="M1314 420H1419V525H1314V420Z" />
                        </mask>
                        <path
                            d="M1419 525V526.091H1420.09V525H1419ZM1419 420H1417.91V525H1419H1420.09V420H1419ZM1419 525V523.909H1314V525V526.091H1419V525Z"
                            fill="#D0D5DD"
                            fillOpacity="0.32"
                            mask="url(#path-141-inside-70_170_4440)"
                        />
                    </g>
                    <rect
                        x="-365.455"
                        y="0.545309"
                        width="2092.91"
                        height="1568.91"
                        stroke="#D0D5DD"
                        strokeOpacity="0.32"
                        strokeWidth="1.09062"
                    />
                </g>
            </g>
            <defs>
                <radialGradient
                    id="paint0_radial_170_4440"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(680 -0.000134707) rotate(90) scale(1130 709.833)"
                >
                    <stop />
                    <stop offset="0.953125" stopOpacity="0" />
                </radialGradient>
                <clipPath id="clip0_170_4440">
                    <rect x="-366" width="2094" height="1570" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default CtaBackground;
